module.exports = __webpack_public_path__ + "static/img/mobile_bg.ddddb7fd.jpg";